import {
  ENCOUNTER_TYPES,
  ENCOUNTER_TYPES_API,
  EncounterType,
  encounterTypeMapping
} from '@/types/encounter';

/**
 * Get encounter type label and path object from mapping
 * @param encounterType
 * @returns object with label and path if encounterType is a valid ENCOUNTER_TYPES_API, else undefined
 */
const encounterTypeFromMapping = (
  encounterType: EncounterType
): { label: string; path: ENCOUNTER_TYPES } | undefined => {
  let encounterTypeObject;

  if (Object.values(ENCOUNTER_TYPES_API).includes(encounterType as ENCOUNTER_TYPES_API)) {
    encounterTypeObject = encounterTypeMapping[encounterType as ENCOUNTER_TYPES_API];
  }

  return encounterTypeObject;
};

export default encounterTypeFromMapping;
